// src/components/public/FAQ_Page.js
// Component to show list of frequently asked questions

import React, { useEffect } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import faqs from "./data/faq";
import Footer from "./Footer";

const FAQPage = ({ numToShow }) => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);
    const displayedFaqs = faqs.slice(0, numToShow);

    return (
        <div className="faq-page">
            <Container fluid className="pb-4">
                <Row className="align-items-center justify-content-center text-left">
                    <Col className="content-style">
                        <h1>Simplify shopping and make time for what truly matters...
                            <span style={{ color: '#f5413a' }}>LIVING!</span>
                        </h1>
                        <p className="sub-text" style={{ color: '#252627' }}>
                            Saarthi transforms grocery shopping into a fun and economical experience,
                            giving you more time to focus on the important stuff.
                        </p>
                    </Col>
                    <Col className="home-banner content-style">
                        <img src="/images/home/living.jpg" alt="Banner" className="img-fluid trapezoid-img-left" />
                    </Col>
                </Row>
            </Container>
            <Container>
                <h1 className="mb-4">Frequently Asked Questions</h1>
                <Accordion defaultActiveKey="0">
                    {displayedFaqs.map(faq => (
                        <Accordion.Item eventKey={faq.id.toString()} key={faq.id}>
                            <Accordion.Header>{faq.question}</Accordion.Header>
                            <Accordion.Body>
                                {faq.answer}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
            <Footer />
        </div>
    );
};

export default FAQPage;